import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { link } from "../../config";
import { useAddress } from "./AddressContext";

function FrameRight(props) {
  const [shippingType, setShippingType] = useState("");
  const [shippingCostVendor, setShippingCostVendor] = useState(0);
  const [shippingCostOrder, setShippingCostOrder] = useState(0);
  const [shippingCostArea, setShippingCostArea] = useState(0);
  const { selectedAddress } = useAddress(); 

  const { t, i18n } = useTranslation();

  // Destructure cartItems and ProductItems from props
  const { cartItems, ProductItems } = props;

  useEffect(() => {
    const fetchShippingExpenses = async () => {
      try {
        const { data } = await axios.get(`${link}shipping-control`);
        setShippingType(data?.data?.name);
      } catch (error) {
        console.log(error);
      }
    };

    fetchShippingExpenses();
  }, []);

  // Initialize totals
  let productTotal = 0;
  let shippingTotal = 0;
  let taxTotal = 0;
  let totalTodayDiscount = 0;
  let totalFlashDiscount = 0;
  let productFlashDiscount = 0;
  let productTodayDiscount = 0;

 
  useEffect(() => {
    const getShippingExpenses = async () => {
      const area = selectedAddress?.area;
      if (shippingType === "order") {
        const { data: shippingCostOrder } = await axios.get(
          `${link}order-flat-rate`
        );
        setShippingCostOrder(shippingCostOrder?.flatRate || 0);
      } else if (shippingType === "vendor") {
        const { data: shippingCostVendor } = await axios.get(
          `${link}vendor-flat`
        );
        setShippingCostVendor(shippingCostVendor?.cost || 0);
      } else if (shippingType === "area") {
        if (area) {
          try {
            const { data: areaCost } = await axios.get(
              `${link}areas-flat/by-name?name=${area}`
            );
            setShippingCostArea(areaCost?.data?.cost || 0);
          } catch (err) {
            console.error("Failed to fetch area shipping cost:", err);
            setShippingCostArea(0);
          }
        } else {
          setShippingCostArea(0);
        }
      }
    };

    getShippingExpenses();
  }, [shippingType, selectedAddress]); // Only run this effect when shippingType changes

  // Loop through the ProductItems to calculate totals
  ProductItems.forEach((item, index) => {
    const quantity = cartItems[index].quantity; // Get the quantity for the item
    const priceAfterDiscount = item.price_after; // Product price after discount
    const shippingCost = item.shipping_cost || 0; // Shipping cost per item
    const taxFlat = item.tax_Flat || 0; // Tax per item

    // Calculate today's discount and flash discount
    const todayDiscount = (item.todayDiscount || []).reduce(
      (sum, discount) => sum + discount.discount,
      0
    );
    productTodayDiscount = todayDiscount;
    const flashDiscount = (item.flashDiscount || []).reduce(
      (sum, discount) => sum + discount.discount,
      0
    );
    productFlashDiscount = flashDiscount;

    // Accumulate the totals, considering the quantity of each product
    productTotal += priceAfterDiscount * quantity;

    if (shippingType === "product") {
      shippingTotal += shippingCost * quantity; // Multiply shipping cost by quantity
      taxTotal += taxFlat * quantity; // Multiply tax by quantity
    } else if (shippingType === "vendor") {
      // Only calculate shipping and tax for products with a valid supplierVendor
      if (item.supplierVendor !== null) {
        shippingTotal += shippingCost * quantity;
        taxTotal += taxFlat * quantity;
      }
    }

    // Accumulate total discounts
    totalTodayDiscount += todayDiscount * quantity;
    totalFlashDiscount += flashDiscount * quantity;
  });

  // Calculate the final price (including product total, shipping, tax, and discounts)
  const finalPriceWithDiscountAndFees =
    productTotal + shippingTotal + shippingCostVendor + shippingCostOrder + shippingCostArea + taxTotal - totalTodayDiscount - totalFlashDiscount;

  return (
    <div className="frame-right d-none d-lg-block">
      <div className="p-2">
        <p>{t("Order Summary")}</p>
        {ProductItems.map((item, index) => (
          <div key={index} className="order-summery-product d-flex mb-1">
            <img src={`${item?.images?.[0]?.secure_url || ""}`} alt="" />
            <div className="d-flex justify-content-between align-items-center flex-grow-1">
              <div className="box d-flex flex-column justify-content-center">
                <div>
                  {i18n.language == "en" ? item?.name : item?.name_ar}{" "}
                  <span> x {cartItems[index].quantity}</span>
                </div>
                <div className="salery">
                  <span>{t("curency")}</span>{" "}
                  {+item.price_after - productFlashDiscount - productTodayDiscount}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white p-2 d-flex flex-column gap-2">
        <div className="order-summery-statictics">
          <span>{t("Order Summary")}</span>
          <span>
            {t("curency")} {(productTotal - totalTodayDiscount - totalFlashDiscount).toFixed(2)}
          </span>
        </div>
        <div className="order-summery-statictics">
          <span>{t("Shipping Expenses")}</span>
          <span>
            {t("curency")} {(shippingTotal + shippingCostVendor + shippingCostOrder + shippingCostArea).toFixed(2)}
          </span>
        </div>
        <div className="order-summery-statictics">
          <span>{t("Including VAT")}</span>
          <span>
            {t("curency")} {taxTotal.toFixed(2)}
          </span>
        </div>
        <div className="order-summery-statictics-total">
          <span>{t("Total")}</span>
          <span>
            {t("curency")} {finalPriceWithDiscountAndFees.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default FrameRight;